import React, { forwardRef } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// ExpandableAccordion.js

const AppExpandableCell = forwardRef(({
    expanded,
    onChange,
    summary,
    details
}, ref) => {
    return (
        <Accordion
            expanded={expanded}
            onChange={onChange}
            ref={ref}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{
                    '&:hover': { bgcolor: 'action.hover'}
                }}
            >
                <Typography fontWeight="medium"> {summary} </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography color="text.secondary"> {details} </Typography>
            </AccordionDetails>
        </Accordion>
    );
});

export { AppExpandableCell };